import { createFileRoute } from "@tanstack/react-router";
import WatIsHusselen from "@/pages/WatIsHusselen";

export const Route = createFileRoute("/wat-is-husselen")({
  head: () => ({
    meta: [
      { title: "Wat is husselen bij tennis? Uitleg, regels & voorbeelden | De Hussel App" },
      { name: "description", content: "Husselen is een speelvorm bij tennis waarbij spelers wisselend aan elkaar gekoppeld worden. Lees wat husselen is, hoe het werkt en hoe je het op je club organiseert." },
      { property: "og:title", content: "Wat is husselen bij tennis? Uitleg, regels & voorbeelden | De Hussel App" },
      { property: "og:description", content: "Husselen is een speelvorm bij tennis waarbij spelers wisselend aan elkaar gekoppeld worden. Lees wat husselen is, hoe het werkt en hoe je het op je club organiseert." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/wat-is-husselen" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/wat-is-husselen" }],
  }),
  component: WatIsHusselen,
});
